import React, { useState, useEffect } from 'react';
import Simulador from '../components/Simulador';
import EnviarConvite from '../components/EnviarConvite';
import Estatisticas from '../components/Estatisticas';
import Feed from '../components/FeedAtividades';
import Monitoramento from '../components/MonitoraFila';
import { firestore } from '../config/firebaseConfig'; 
import { collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore'; 
import EnviarPilula from '../components/EnviarPilula';
import Modal from 'react-modal';
import Agendamentos from '../components/Agendamentos';
import Relatorios from '../components/Relatorios';
import Cursos from '../pages/Cursos';

Modal.setAppElement('#root');

function Home() {
  const [hasPendingContacts, setHasPendingContacts] = useState(false);
  const [isPilulaModalOpen, setIsPilulaModalOpen] = useState(false);
  const [isSimuladorModalOpen, setIsSimuladorModalOpen] = useState(false);
  const [logoUrl, setLogoUrl] = useState(''); 

  useEffect(() => {
    const checkPendingContacts = async () => {
      try {
        const contatosRef = collection(firestore, 'contatos');
        const q = query(contatosRef, where('status', '==', 'Pendente'));
        const querySnapshot = await getDocs(q);
        
        setHasPendingContacts(!querySnapshot.empty);
      } catch (error) {
        console.error('Erro ao buscar contatos:', error);
      }
    };

    checkPendingContacts();
  }, []);

  useEffect(() => {
    // Carrega o tenantId do localStorage
    const tenantId = localStorage.getItem('tenantId');
    if (!tenantId) {
      console.error('Tenant ID não encontrado');
      return;
    }

    // Função para buscar o logoUrl no Firestore
    const fetchLogoUrl = async () => {
      try {
        const tenantDocRef = doc(firestore, 'inquilinos', tenantId);
        const tenantDocSnap = await getDoc(tenantDocRef);

        if (tenantDocSnap.exists()) {
          const data = tenantDocSnap.data();
          setLogoUrl(data.logoUrl || ''); // Define o logoUrl se ele existir no Firestore
        } else {
          console.error('Documento não encontrado para o tenantId:', tenantId);
        }
      } catch (error) {
        console.error('Erro ao buscar o logoUrl:', error);
      }
    };

    fetchLogoUrl();
  }, []);

  // Funções para abrir e fechar os modais
  const openPilulaModal = () => setIsPilulaModalOpen(true);
  const closePilulaModal = () => setIsPilulaModalOpen(false);

  const openSimuladorModal = () => setIsSimuladorModalOpen(true);
  const closeSimuladorModal = () => setIsSimuladorModalOpen(false);

  return (
    <>
      <div className="home-container">  
        {logoUrl ? (
          <img src={logoUrl} alt="Logo da HB Escola de Negócios" className="home-logo" />
        ) : (
          <p>Carregando logotipo...</p>
        )}
 	<Cursos />
	 <Monitoramento />
{/* <Estatisticas />*/}
  
  {/* Wrapper para agrupar Processamento de Fila e Card Dinâmico */}
  <div className="processamento-fila-wrapper">
    <div className={hasPendingContacts ? "processamento-fila-33" : "processamento-fila-50"}>
      <Agendamentos />  
    </div>
    
    {hasPendingContacts && (
      <div className="processamento-fila-33">
        <EnviarConvite />
      </div>
    )}

    <div className={hasPendingContacts ? "processamento-fila-33" : "processamento-fila-50"}>
      <Relatorios />  
    </div>
          
          {/* Renderiza EnviarConvite apenas se hasPendingContacts for true */}
          
        </div>
      </div>


      <Feed />
      <div style={{ height: '1px' }}></div>


      {/* Modal do Enviar Pílula */}
      <Modal
        isOpen={isPilulaModalOpen}
        onRequestClose={closePilulaModal}
        contentLabel="Enviar Pílula"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        {/* <EnviarPilula /> */}
        <button onClick={closePilulaModal} className="close-modal-button">Fechar</button>
      </Modal>

      {/* Modal do Simulador */}
      <Modal
        isOpen={isSimuladorModalOpen}
        onRequestClose={closeSimuladorModal}
        contentLabel="Simulador"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        {/* <Simulador /> */}
        <button onClick={closeSimuladorModal} className="close-modal-button">Fechar</button>
      </Modal>
    </>
  );
}

export default Home;
